import React, { FC, useEffect, useState } from "react"
import { TrendTopTrack } from "../../../../types"
import { KSpan } from "kahuna-base-react-components"
import NotFound from "../../../NotFound"
import { lang } from "../../../../constants/languages"

type StreamsTopTracksProps = {
  trendTopTracks: TrendTopTrack[]
}

const StreamsTopTracks: FC<StreamsTopTracksProps> = (props) => {
  const { trendTopTracks } = props

  const [hoverId, setHoverId] = useState<number>()

  return (
    <div className="w-full h-full">
      <div
        className="py-5 px-7 min-h-[100%]"
        style={{
          borderRadius: "10px",
          border: "1px solid var(--stroke-soft-200, #F3F3F3)",
          background: "var(--bg-white-0, #FFF)",
          boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)"
        }}
      >
        <div>
          <div className="flex mb-4" style={{ width: "100%" }}>
            <div style={{ width: "30%" }}>
              <KSpan color="#111" text={"Track Title"} />
            </div>
            <div style={{ width: "30%" }}>
              <KSpan color="#111" text={"Artist(s)"} />
            </div>
            <div style={{ width: "14%" }}>
              <KSpan color="#111" text={"Streams"} />
            </div>
            <div style={{ width: "16%" }}>
              <KSpan color="#111" text={"Stream Change"} />
            </div>
            <div style={{ width: "10%" }}>
              <KSpan color="#111" text={"Position"} />
            </div>
          </div>
          {trendTopTracks && !(trendTopTracks.length > 0) && (
            <div className="flex p-5 w-full justify-center mt-[100px]">
              <NotFound title={lang.not_found.trends.title} description={lang.not_found.trends.desc} imageWidth={400} />
            </div>
          )}
          {trendTopTracks?.map((trendTopTrack) => {
            const background = hoverId === trendTopTrack.id ? "#00000008" : "transparent"
            const isPositiveChange = trendTopTrack.streamChange > 0
            return (
              <div
                className="flex p-2"
                style={{ width: "100%", background, borderRadius: "5px" }}
                key={`trend_top_track_${trendTopTrack.position}`}
                onMouseOver={() => setHoverId(trendTopTrack.id)}
              >
                <div style={{ width: "30%" }}>
                  <KSpan text={trendTopTrack.track?.title || "-"} />
                </div>
                <div style={{ width: "30%" }}>
                  <KSpan text={trendTopTrack.track?.artistList?.map((artist) => artist.name)?.join(", ") || "-"} />
                </div>
                <div style={{ width: "14%" }}>
                  <KSpan text={trendTopTrack.streams?.toString() || "-"} />
                </div>
                <div style={{ width: "16%" }}>
                  <KSpan
                    text={`${isPositiveChange ? "+" : ""}${trendTopTrack.streamChange?.toString() || "-"}`}
                    color={isPositiveChange ? "#56E099" : "#FF5865"}
                  />
                </div>
                <div style={{ width: "10%" }}>
                  <KSpan text={trendTopTrack.position?.toString() || "-"} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StreamsTopTracks
